import React from "react"
import AdminPanelDom from "../domains/adminPanel/adminPanelDom"
import ProductsPage from "./ProductsPage"

class AdminPanelProducts extends React.Component {
  render() {
    return (
      <AdminPanelDom
        component={({ MessaggiComponent }) => (
          <ProductsPage forAdmin={true} MessaggiComponent={MessaggiComponent} />
        )}
        {...this.props}
      />
    )
  }
}
export default AdminPanelProducts
